import SwiperSlider, { SwiperSlide } from "../../components/swiper";
import img1 from "../../assets/images/Home/home_logo_1.png";
import img2 from "../../assets/images/Home/home_logo_2.png";
import img3 from "../../assets/images/Home/home_logo_3.png";

const settings = {
  loop: false,
  slidesPerView: "auto",
  spaceBetween: 30,
};

const data = [
  { id: 1, img: img1 },
  { id: 2, img: img2 },
  { id: 3, img: img3 },
];

const HomeLogoSlider = () => {
  return (
    <section className="home_logo_slider_section">
      <div className="container">
        <div className="heading_top">
          <h4 className="heading_with_line center_aligned">
            Associated with credibility
          </h4>
          <h2 className="section_main_heading">OUR ASSOCIATION</h2>
        </div>
        <SwiperSlider options={settings}>
          {data.map((item) => (
            <SwiperSlide key={item.id}>
              <img src={item.img} alt="logo" className="logo_image" />
            </SwiperSlide>
          ))}
        </SwiperSlider>
      </div>
    </section>
  );
};

export default HomeLogoSlider;
